import React from 'react';
import {connect} from 'react-redux';
import {injectIntl} from "react-intl";
import $ from "jquery";

import MobileNavigationCommon from "../../visComponents/navigation/mobileNavigationCommon";

import {ContentType} from "../../visComponents/constants";

import MobileNavigationButtons from '../../visComponents/navigation/mobile/mobileNavigationButtons';
import MobileNavigationAllWallsCheckbox from '../../visComponents/navigation/mobile/mobileNavigationAllWallsCheckbox';
import FeatureWizardSteps from "../../visComponents/navigation/featureWizard/featureWizardSteps";

import {changeActivePartRelatedItemIndex, setDefaultSelectionGroup} from "../../../actions/actionFunctions";
import {
  setActiveNavigationFilter,
  setModuleContextMenuType,
  setModuleContextMenuModule,
  setActiveNavigationFilterStepIndex, setNavigationViewType, setNavigationLoading, toggleNavItemPositionModal
} from "../../../actions/navigationFunctions";

import MobileMenuSelect from '../../visComponents/navigation/mobile/mobileMenuSelect';
import LockedView from "../../common/lockedView";

import Filters from "../../visComponents/navigation/newFilters/filters";
import BodyPanelRadio from "../../visComponents/navigation/desktop/bodyPanelRadio";
import FilterSwitchers from "../../visComponents/navigation/newFilters/filterSwitchers";
import FilterSelection from "../../visComponents/navigation/newFilters/filterSelection";
// import {CABINET_WIZARD_BUTTONS} from "../core/constants";
import NavigationFiltersSteps from "../../visComponents/navigation/newFilters/navigationFiltersSteps";
import ContextMenuQKB, {checkForContextMenuCommon} from "./contextMenuQKB";

import {getCurrentLayout} from "../../appLayout";
import CountertopSwitchers from "../../kvComponent/navigation/countertopSwitchers";
import NavItemPositionModal from "../../visComponents/navigation/navItemPositionModal";
import {setLookContextMenu} from "../../../actions/lookFunctions";
import LookAllWallsRadioButton from "../../look/lookNavigation/lookMain/lookAllWallsRadioButton";

class MobileNavigation extends MobileNavigationCommon {

  UNSAFE_componentWillReceiveProps(nextProps) {
    this._UNSAFE_componentWillReceiveProps(nextProps)
  }

  checkForContextMenu = (hoveredLayer, event) => {
    if (this.props.contextMenu.opened) {
      this.props.setLookContextMenu({
        opened: false
      })
      return true
    }
    if (!hoveredLayer || this.state.showNavigation) {
      return false
    }

    const {showButtons} = checkForContextMenuCommon(hoveredLayer.partId, hoveredLayer.layerPosition);
    if ((showButtons.length > 1) && !(hoveredLayer.partId && hoveredLayer.partId === "vanity_legs")) {
      this.props.setLookContextMenu({
        opened: true,
        partId: hoveredLayer.partId,
        layerPosition: hoveredLayer.layerPosition, // if needed
        position: {
          x: event.clientX,
          y: event.clientY,
        }
      });
      return true
    } else if (showButtons.length === 1 && showButtons[0].includes("_wizard")) {
      // const wizardId = showButtons[0].split("-")[1];
      // setWizardActiveItem(wizardList.find(wizardItem => wizardItem.id === wizardId));
      //
      // history.push(`${getLookIdUrl(false) + ROUTES.wizard}/${wizardId}`);
      return true
    }
    return false
  }

  handleContextMenuClick = (featureToClick, partId) => {
    const layout = getCurrentLayout();
    let clickedParent = "", clickedButton = "";
    const featureGroup = layout.getFeatureGroupByPartId(partId);
    if (featureGroup) {
      clickedButton = featureGroup.partName;
      clickedParent = featureGroup.getParent().partName;
    }
    //
    // console.log('clickedButton', clickedButton);
    // console.log('clickedParent', clickedParent);
    if (!clickedButton) {
      return
    }
    // console.log('menuItem', menuItem);
    // if (clickedParent === "Walls" && (clickedButton === "Left Shower Wall" || clickedButton === "Pony Wall")) {
    //   this.ponyWallAndLeftWallClick(menuItem);
    // }

    this.setState({
      showNavigation: true,
      contentType: ContentType.Design,
      contextMenuOpen: false,
      hoveredLayer: {}
    }, () => {
      this.menuOpened();
      this.triggerOpenNavigationMenu(clickedButton, clickedParent);
      $(document).on('click', this.handleWrapperBlur);
      this.setNewActiveFeature();
      if (featureToClick) {
        featureToClick.handleClick();
      }
    });
  };

  bindCanvasClick = (event) => {
    // const canvas = document.getElementById(this.props.canvasId);

    if (!window.touchMove && !this.state.showNavigation && !this.props.contextMenu.opened) {
      this.props.setHoveredLayer(event);
    }

    if (document.hoveredLayer && !window.touchMove) {
      // $('.canvas-text').html(`CLICK3`);

      if (this.checkForContextMenu(document.hoveredLayer, event)) {
        return false
      }

      const hoveredPartId = document.hoveredLayer.partId;

      if (hoveredPartId) {
        if (this.state.contentType === 0) {
          this.openMobileMenu();
        }
        const layout = getCurrentLayout();
        const featureGroup = layout.getFeatureGroupByPartId(hoveredPartId);
        if (featureGroup) {
          this.triggerOpenNavigationMenu(featureGroup.partName, featureGroup.getParent().partName)
          if (!window.canvasIsDragging) {
            this.props.setCanvasClass(featureGroup.partName.toLowerCase().replace(/ /g, "-"));
          }
        }
      }
    }
  };

  handleNavigationItemClick = (item, ignoreLocked = false, featureIsLocked, event) => {
    //console.log('item', item);

    if (this.state.childNavigationItem
      && this.state.childNavigationItem.part.activeFeature
      && Array.isArray(this.state.childNavigationItem.part.activeFeature.metaData["SkuName"])
      && this.state.childNavigationItem.part.activeFeature.metaData["SkuName"][0]
      && Array.isArray(item.part.metaData["SkuName"])
      && (this.state.childNavigationItem.part.activeFeature.metaData["SkuName"][0] === item.part.metaData["SkuName"][0])) {
      this.showPositionsPopup(item, event); // move modal to new position
      return false // don't change L to R // redundant click
    }

    const showPositionPopup = this.showPositionsPopup(item, event);
    if (showPositionPopup) {
      this.props.setActiveFeature(item.part); // set feature for modal
      return // don't click on feature!! we are clicking inside the modal window
    }

    if (item.matchesMetaFailed) {
      let nonCompatibleWith = "";
      switch (item.part.partId) {
        case "vanity_faucet":
          nonCompatibleWith = "sink";
          break;
        case "sink":
          nonCompatibleWith = "vanity";
          break;
        case "shower_pod":
          nonCompatibleWith = "Window Kit";
          break;
        case "window_kits":
          nonCompatibleWith = item.matchesMetaFailed === "shower_pod" ? "Shower Pod" : "Corner Shelf";
          break;
        default:
          break;
      }
      this.callMetaMathesFailedPopup(item, nonCompatibleWith);
    } else if (item.part.partId === "vanity_sink" && this.state.parentNavigationItem.part.faucet.placeholderChanged
      && this.state.parentNavigationItem.part.faucet.activeFeature) {
      const sinkSizeConditionValue = item.part.metaData["SinkSize"] ? item.part.metaData["SinkSize"][0] : null;
      if (sinkSizeConditionValue && !this.state.parentNavigationItem.part.faucet.activeFeature.matchesMetaForCondition('SinkSize', sinkSizeConditionValue)) {
        this.callMetaMathesFailedPopup(item, 'faucet');
      } else {
        this.itemClick(item, ignoreLocked)
      }
    } else {
      this.itemClick(item, ignoreLocked)
    }

    this.props.setActiveFeature(item.part);

    const canvasClass = this.state.childNavigationItem
      ? this.state.parentNavigationItem.text + '-' + this.state.childNavigationItem.text
      : this.state.parentNavigationItem.text;

    if (!window.canvasIsDragging) {
      this.props.setCanvasClass(canvasClass.toLowerCase().replace(/ /g, "-"));
    }

    if (this.state.parentNavigationItem) {  // update canvas only if it is child
      this.props.refreshCB();
    }
  };

  handleSubPartClick = subNavigationItem => { // sidebar list item click
    const subItemPart = subNavigationItem.part;
    subItemPart.getParent().handleSubPartClick(subItemPart);
    this.setState({
      childNavigationItem: subNavigationItem,
      showFilterSelection: subItemPart.allFeaturesReceived, // show filters only if subItemPart has all features
      showerWallWizardGroupsSelected: false,
      searchText: ""
    }, () => {
      this.scrollContentToTop();
      this.rememberWallsSelection();
      this.checkIfAllFeaturesReceived(subNavigationItem, "childNavigationItem");
    });
    /*set new materials page subIndex*/
    this.setActivePartRelatedItemIndex(subNavigationItem);
    // console.log('subItemPart', subItemPart);
    if ((subItemPart.getParent() && subItemPart.getParent().partName === "Walls")
      || subItemPart.partName === "Accent Wall" && !window.canvasIsDragging) {
      this.props.setCanvasClass(subNavigationItem.text.toLowerCase().replace(/ /g, "-"));
    }
    this.setNewActiveFeature(subNavigationItem);
  };

  render() {
    const layout = getCurrentLayout();
    const activePart = this.state.parentNavigationItem ? this.state.parentNavigationItem.part : null;
    const activeSubPart = this.state.childNavigationItem ? this.state.childNavigationItem.part : null;
    const activeNavPart = activeSubPart || activePart;
    const parentItems = layout.designNavigationItems();  // parent list without filters
    const allFeaturesReceived = activeNavPart && activeNavPart.allFeaturesReceived;

    // console.log('activePart', activePart);
    // console.log('activeSubPart', activeSubPart);
    // console.log('activePart.subTypes()', activePart && activePart.subTypes());
    // console.log('this.state.childNavigationItemv1111', this.state.childNavigationItem);

    let useWizard = false;
    let wizardGroups = [];
    if (this.props.fabricatorSettings
      && (this.props.fabricatorSettings.wizardConsumers || (this.props.fabricatorSettings.wizardClients && document.kvConfig.isBackend))
      && this.state.contentType === ContentType.Design && activeSubPart && activeSubPart.canUseWizard && activeSubPart.allFeaturesReceived) {
      const partWizardGroups = this.getWizardGroupsForPartId(this.state.childNavigationItem.part.partId);
      useWizard = !!partWizardGroups; // canUseWizard parts without wizard groups use the normal selection UI
      wizardGroups = partWizardGroups || [];
    }

    const features = this.getFeatures(layout);

    const showLockedView = this.currentActiveItemIsLocked(useWizard);

    const useFilters = (activePart && activePart.partId === "kitchen_floor" && activePart.allFeaturesReceived)
      || (activeSubPart && (this.isWallItem(activeSubPart) || activeSubPart.partId === "accent_wall"
        || activeSubPart.partId === "shower_wall_accent") && activeSubPart.allFeaturesReceived);

    const filterSelectionHasValues = activeNavPart && FilterSelection.getAvailableFilterValues(
      this.props.filterGroups, "Material", activeNavPart, this.props.fabricatorData
    ).length;

    const itemIsSelected = (!this.props.fabricatorSettings.leadCapture
      || (activeSubPart && activeSubPart.activeFeature && activeSubPart.firstClick[this.props.activeQuoteIndex] && activeSubPart.placeholderChanged));

    const useKVWizard = false;
    //TODO change it when BE is ready

    const showNavigationFilters = useKVWizard &&activeNavPart
      // && this.props.activeNavigationFilter !== CABINET_WIZARD_BUTTONS[0].buttonId
      && activeNavPart.canUseNavigationFilter && activeNavPart.canUseNavigationFilter();

    let showNavigationFiltersSteps = false;
    if (useKVWizard && activeNavPart && activeNavPart.canUseNavigationFilterSteps
      && activeNavPart.canUseNavigationFilterSteps()) {
      showNavigationFiltersSteps = !this.props.countertopNavigationFilterCompleted;
    }

    // console.log("isCountertop", isCountertop);

    return (
      <div className={"menu-wrapper"
      + (this.state.showNavigation || this.state.contextMenuOpen ? " menu-overlay--fullwidth" : "")}>
        <div className={"menu" + (this.state.showNavigation ? " menu--opened" : "")}>
          {/*<button className="menu-opener" onClick={this.toggleMobileMenu}/>*/}
          <div className={"menu-inner" + (this.state.searchInputFocused ? " menu-inner--search-input-focused" : "")}>
            <div className="menu-header">
              <div
                className={"menu-header__left"
                + (this.state.childNavigationItem ? " menu-header__left--with-border" : "")}>
                {this.state.childNavigationItem && this.state.childNavigationItem.part.canBeDisabled ? (
                  <BodyPanelRadio updateRadio={this.state.updateRadio}
                                  isMobile={true}
                                  activeSubPart={this.state.childNavigationItem.part}
                                  handleRadioButtonClick={this.handleRadioButtonClick}/>
                ) : null}
                {activeSubPart
                  ? layout.isNewLayout
                    ? <LookAllWallsRadioButton lookFeature={activeSubPart.activeFeature}/>
                    : <CountertopSwitchers isMobile={true} activeSubPart={activeSubPart}/>
                  : null}
                {activeSubPart && this.isWallItem(activeSubPart) && activeSubPart.partName !== "Accent Wall"
                  ? <MobileNavigationAllWallsCheckbox
                    parentNavigationItem={this.state.parentNavigationItem}
                    toggleApplyWallsCheckbox={this.toggleApplyWallsCheckbox}/>
                  : null}
              </div>
              <MobileNavigationButtons contentType={this.state.contentType}
                                       searchText={this.state.searchText}
                                       canvasId={this.props.canvasId}
                                       parentNavigationItem={this.state.parentNavigationItem}
                                       handleSearchInputChange={this.handleSearchInputChange}
                                       changeMessageBoxState={this.props.changeMessageBoxState}
                                       resetEverything={this.resetEverything}
                                       userIsLoggedIn={this.props.userIsLoggedIn}
                                       toggleUserPopup={this.props.toggleUserPopup}
                                       handleChangeContentType={this.handleChangeContentType}/>
            </div>
            {useFilters && this.state.showFilterSelection && filterSelectionHasValues
            && (this.state.contentType === ContentType.Design) ? (
              <FilterSelection removeFilterSelection={this.removeFilterSelection}
                               filterGroupName="Material"
                               activePart={activeNavPart}
                               isMobile={true}
              />
            ) : (
              this.state.showFeatureWizard ? (
                useWizard && this.state.childNavigationItem && this.state.childNavigationItem.part
                  ? this.contentDesignWizard()
                  : this.contentBody(features, showNavigationFilters || showNavigationFiltersSteps, useFilters, activePart, activeSubPart, filterSelectionHasValues, allFeaturesReceived)
              ) : this.contentBody(features, showNavigationFilters || showNavigationFiltersSteps, useFilters, activePart, activeSubPart, filterSelectionHasValues, allFeaturesReceived)
            )}
            {useWizard && !this.state.showFeatureWizard && !useFilters
            && (this.state.contentType === ContentType.Design) ? (
              <FeatureWizardSteps
                availableSteps={wizardGroups.filter(step => !step.hidden)}
                featureWizardStep={this.state.wizardStepIndex}
                setFeatureWizardStep={this.setWizardStepIndex}
                exitFeatureWizard={this.exitFeatureWizard}
                getFilterDisplayName={this.getFilterDisplayName}
                isMobile={true}
                isPhoneNumberValidated={this.props.isPhoneNumberValidated}
                allProducts={true}
                showFeatureWizard={this.state.showFeatureWizard}
                enableFeatureWizard={this.enableFeatureWizard}
                toggleWizardFilterSelection={this.toggleWizardFilterSelection}
                allStepsCompleted={wizardGroups.every(step => step.selectedValueId) || itemIsSelected}
              />
            ) : null}
            {showNavigationFilters || showNavigationFiltersSteps ? (
              <NavigationFiltersSteps
                activePart={activeNavPart}
                isMobile={true}
              />
            ) : null}
            {useFilters && !this.state.showFilterSelection && filterSelectionHasValues ? (
              <FilterSwitchers activePart={activeNavPart} filterGroupName="Material" isMobile={true}/>
            ) : null}
            {this.state.contentType === ContentType.Design && this.state.parentNavigationItem
            && !(useWizard || showNavigationFilters || showNavigationFiltersSteps || (useFilters && filterSelectionHasValues)) ? (
              <MobileMenuSelect parentItems={parentItems}
                                activePart={activePart}
                                activeSubPart={activeSubPart}
                                onSubPartClick={this.handleSubPartClick}
                                onParentItemClick={this.handleParentItemClick}/>
            ) : null}
          </div>
        </div>
        <ContextMenuQKB handleContextMenuClick={this.handleContextMenuClick} />
        {showLockedView
          ? <LockedView setActiveFeature={this.resetActiveFeature} handleUserLoginClick={this.handleUserLoginClick}/>
          : null}
        <Filters
          id="mobileNavigation"
          searchText={this.state.searchText}
          handleSearchInputChange={this.handleSearchInputChange}
          childItem={this.state.childNavigationItem}/>
        {this.props.bvOpened ? <NavItemPositionModal activeFeature={this.props.activeFeature}/> : null}
      </div>
    )
  }
}

const mapStateToProps = (store) => {
  const {contextMenu} = store.lookState;
  return {
    fabricatorData: store.fabricatorState,
    selectedFilters: store.filterState.selectedFilters,
    filtersVisible: store.filterState.showFilters,
    filterGroups: store.filterState.filterGroups,
    bvPresets: store.bathroomVisualizerState.bvPresets,
    bvOpened: store.bathroomVisualizerState.bvOpened,
    userPopupOpened: store.userState.userPopupOpened,
    activeNavigationFilter: store.navigationState.activeNavigationFilter,
    countertopNavigationFilterCompleted: store.navigationState.countertopNavigationFilterCompleted,
    newLayoutType: store.sqftState.newLayoutType,
    countertopsApplyTo: store.navigationState.countertopsApplyTo,
    activeQuoteIndex: store.quotesState.activeQuoteIndex,
    navItemPositionModal: store.navigationState.navItemPositionModal,
    contextMenu,
  }
}

const mapDispatchToProps = {
  setNavigationViewType,
  setModuleContextMenuType,
  setDefaultSelectionGroup,
  changeActivePartRelatedItemIndex,
  setActiveNavigationFilter,
  setActiveNavigationFilterStepIndex,
  setModuleContextMenuModule,
  setNavigationLoading,
  toggleNavItemPositionModal,
  setLookContextMenu,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(MobileNavigation)
);
